import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {FullWidthColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {PlainBackLink} from '../../../../styledComponents/Links'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    ApplyButton,
    BoldText,
    ListGridContainer,
    PageTitle,
    PledgeArea,
    PolicyCheckBoxStyled,
    WideWhiteArea,
} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId?: string
    location: Location
}

interface State {
    policyChecked: boolean
    applyButtonDisabled: boolean
}

class NatResidentBikeParkingUseApplyAgreementPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            policyChecked: false,
            applyButtonDisabled: true,
        }

        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)
        this.onClickApplyButton = this.onClickApplyButton.bind(this)
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            policyChecked: event.target.checked,
        }, () => {
            this.updateApplyButtonDisabled()
        })
    }

    updateApplyButtonDisabled(): void {
        const {policyChecked} = this.state

        if (policyChecked) {
            this.setState({applyButtonDisabled: false})
        } else {
            this.setState({applyButtonDisabled: true})
        }
    }

    onClickApplyButton(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/bikeParkingUses/input`,
            {
                state: {
                    applyId: this.props.applyId,
                },
            },
        )
    }

    renderPolicy(): Nullable<ReactElement> {

        return (<>
            <Box height={'15px'}/>
            <PledgeArea fontSize={FontSize.Middle}>
                <Box p={'10px'}>
                    <BoldText fontColor={Colors.AccentDark}>誓約文</BoldText>
                    <Box height={'5px'}/>
                    私は、本マンションバイク置場を使用したいので、バイク置場使用規則に掲げる区画寸法等を確認のうえ、次のとおり申込をいたします。
                </Box>
            </PledgeArea>
            <Box height={'20px'}/>
            <FullWidthColumnFlexContainer>
                <PolicyCheckBoxStyled>
                    <LeftRowFlexContainer>
                        <input
                            type="checkbox"
                            checked={this.state.policyChecked}
                            onChange={this.onChangePolicyChecked}
                        />
                        <BlockSpacer width={'10px'}/>
                        誓約文に同意する
                    </LeftRowFlexContainer>
                </PolicyCheckBoxStyled>
            </FullWidthColumnFlexContainer>
        </>)
    }


    render(): ReactElement {

        return (
            <>
                <PlainBackLink
                    to={this.props.applyId
                        ? `/resident/condominiums/${this.props.condominiumCd}/applications/bikeParkingUses/${this.props.applyId}`
                        : `/resident/condominiums/${this.props.condominiumCd}/applications`}>
                    戻る
                </PlainBackLink>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    バイク置場使用申込
                </PageTitle>
                <Box height={'20px'}/>
                <Box>
                    バイク置場を使用する場合に必ず提出が必要です。
                    <BoldText>使用する区画を事前にご確認いただいたうえ</BoldText>で本申請手続きを実施してください。
                    申込完了後、契約書がご自宅に送付されますので内容を確認し、押印・返送をお願いいたします。
                    <Box height={'10px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <div>・</div>
                        <div>
                            1区画ごとに申請が必要です。
                        </div>
                        <div>・</div>
                        <div>
                            区画内容（空き区画の有無、区画の場所、料金等）については管理事務室にてご確認ください。
                        </div>
                        <div>・</div>
                        <div>
                            バイクを変更する場合は、バイク変更届を提出してください。
                        </div>
                    </ListGridContainer>
                </Box>
                <Box height={'15px'}/>
                <WideWhiteArea>
                    <Box mt={'15px'}>
                        <BoldText fontColor={Colors.AccentDark}>ご準備いただくもの</BoldText>
                        <Box height={'5px'}/>
                        <ListGridContainer fontSize={'16px'}>
                            <div>・</div>
                            <div>
                                以下のいずれかの証明書
                            </div>
                            <div></div>
                            <div>
                                車検証、軽自動車届出済証、標識交付証明書
                            </div>
                        </ListGridContainer>
                        <Box height={'20px'}/>
                    </Box>
                </WideWhiteArea>
                {this.renderPolicy()}
                <ApplyButton
                    disabled={this.state.applyButtonDisabled}
                    onClick={this.onClickApplyButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            申請を開始する
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentBikeParkingUseApplyAgreementPage)
